package com.flowyride.app.config

import kotlinx.browser.window

/** The web app is served by the FlowyRide server itself: same origin, no CORS, no URL to configure. */
internal actual fun platformDefaultServerUrl(): String? = window.location.origin
